import React, { useCallback } from "react";
import FilterBarContainer from "containers/FilterBar";
import { getLocalizedText } from "data/utils";

type Props = {
    aggregations: ?Array<SearchBucketDTO>,
    selected: Array<SearchFilterDTO>,
    onSelect: (
        name: string,
        valueType: SearchValueTypeEnum,
        value: any
    ) => void,
    onClear: () => void,
    viewMode: string,
    viewModes: Array<string>,
    onViewModeChange: (viewMode: string) => void,
    searchText?: string,
    onFilterTextChange?: (filterText: string) => void,
};

const SearchResultsFilterBar = ({
    aggregations,
    selected,
    onSelect,
    onClear,
    viewMode,
    viewModes,
    onViewModeChange,
    searchText = null,
    onFilterTextChange = null,
}: Props) => {
    const handleFilterTextChange = useCallback(
        (filterText: string) => onFilterTextChange?.(filterText),
        [onFilterTextChange]
    );
    return (
        <FilterBarContainer
            filterText={searchText ?? ""}
            onFilterTextChange={handleFilterTextChange}
            filterTextPlaceholder={getLocalizedText(
                "$searchresult:quickfilter"
            )}
            aggregations={aggregations}
            selected={selected}
            onSelect={onSelect}
            onClear={onClear}
            viewMode={viewMode}
            viewModes={viewModes}
            onViewModeChange={onViewModeChange}
        />
    );
};

export default SearchResultsFilterBar;
